export const DEFAULT_PAGE_SIZE = 5;

export const BE_DATE_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss[.]SSSZZ';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_DISPLAY_FORMAT = 'DD/MM/YYYY';
export const DATE_DISPLAY_FORMAT_FULL = 'DD/MM/YYYY HH:mm';

export const DEBOUNCE_TIMEOUT = 700;

export const ENTRIES_RECEIVED_ACTIVE_SERIES_TEXT =
  'Entries have been received for the current series for this syllabus/specification. Only those with ‘Super Administrator’ access are permitted to change business rules, as the impact of doing this during a series could result in centres submitting different documents for the same series, or similar.';
